export const REDUCER_NAME = 'search'



// WEBPACK FOOTER //
// ./src/modules/voucher/state/search/const.js